export const renderTime = (time) => {
  return `${time.hours}:${time.minutes} ${time.ampm ? time.ampm : ""}`;
};
